import { createTheme } from '@mui/material/styles';

// Paleta de cores principal do RealMed
const cores = {
    primaria: {
        principal: '#006633',
        clara: '#00874a',
        maisClara: '#00a85f',
        escura: '#00522a',
    },
    secundaria: {
        principal: '#0f766e',
        clara: '#0d9488',
    },
    fundo: {
        padrao: '#ffffff',
        papel: 'rgba(255,255,255,0.97)',
        claro: '#f8fafc',
    },
    texto: {
        primario: '#1e293b',
        secundario: '#475569',
        terciario: '#64748b',
        desabilitado: '#94a3b8',
    },
    cinza: {
        claro: '#f1f5f9',
        medio: '#94a3b8',
        escuro: '#64748b',
    },
    erro: {
        principal: '#ef4444',
        claro: '#fef2f2',
        medio: '#fca5a5',
        escuro: '#dc2626',
    },
    aviso: {
        principal: '#f59e0b',
    },
    sucesso: {
        principal: '#10b981',
    },
    gradientes: {
        primario: 'linear-gradient(135deg, #006633 0%, #00874a 100%)',
        secundario: 'linear-gradient(135deg, #00522a 0%, #00a85f 100%)',
        fundo: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    },
    sombras: {
        padrao: '0 4px 15px rgba(0,102,51,0.13)',
        elevada: '0 8px 32px rgba(0,102,51,0.12)',
        botoes: '0 4px 15px rgba(0,102,51,0.13)',
        suave: '0 2px 4px rgba(0,0,0,0.05)',
        medio: '0 4px 8px rgba(0,0,0,0.1)',
    },
};

// Tema RealMed
const tema = createTheme({
    palette: {
        primary: {
            main: cores.primaria.principal,
            light: cores.primaria.clara,
            dark: cores.primaria.escura,
            contrastText: '#ffffff',
        },
        secondary: {
            main: cores.secundaria.principal,
            light: cores.secundaria.clara,
            contrastText: '#ffffff',
        },
        error: {
            main: cores.erro.principal,
        },
        warning: {
            main: cores.aviso.principal,
        },
        success: {
            main: cores.sucesso.principal,
        },
        text: {
            primary: cores.texto.primario,
            secondary: cores.texto.secundario,
            disabled: cores.texto.desabilitado,
        },
        background: {
            default: cores.fundo.padrao,
            paper: cores.fundo.papel,
        },
    },
    shape: {
        borderRadius: 8, // Raio de borda padrão
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 700,
        },
        h5: {
            fontWeight: 700,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 8,
                    fontWeight: 600,
                },
                contained: {
                    boxShadow: cores.sombras.botoes,
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 8,
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                },
            },
        },
    },
});

// Exporta as cores individuais para uso direto
export { cores };

// Exporta o tema padrão
export default tema;
